import React from "react";
import styled from "styled-components";
import ScreenWrapper from "../shared/ScreenWrapper";
import styles from "../../utility/styles";

export default function GiveGiftCancel() {
    return (
        <ScreenWrapper></ScreenWrapper>
    )
}